import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import APIcon, { APIconName } from "../../../components/buttons/APIcon";
import {
  formatReleaseDate,
  standardVehicleValueFormatter,
} from "../../../helpers/vehicle";
import { APVehicleVariant } from "../../../types/Vehicles";

export const VehicleVariantSummarisedSpecs = ({
  vehicleVariant,
  includeRows,
  noIconGap = false,
  priceToBeConfirmed = false,
}: {
  vehicleVariant: APVehicleVariant;
  includeRows: ("money" | "car" | "speedometer" | "range")[];
  noIconGap?: boolean;
  priceToBeConfirmed?: boolean;
}) => {
  const renderSpecRow = (
    icon: APIconName,
    text: string,
    secondaryText?: string,
    tertiaryText?: string
  ) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            width: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <APIcon name={icon} size="large" />
        </Box>
        <Stack ml={noIconGap ? 0 : 1}>
          <Typography variant="titleMedium">{text}</Typography>
          {secondaryText && (
            <Typography variant="titleMedium">{secondaryText}</Typography>
          )}
          {tertiaryText && (
            <Typography variant="titleMedium">{tertiaryText}</Typography>
          )}
        </Stack>
      </Box>
    );
  };
  const rangeText = vehicleVariant.range
    ? `${standardVehicleValueFormatter("range", vehicleVariant.range)} Range`
    : undefined;
  const fuelEconomyText = vehicleVariant.fuelEconomy
    ? `${standardVehicleValueFormatter(
        "fuelEconomy",
        vehicleVariant.fuelEconomy
      )} Fuel Economy`
    : undefined;

  return (
    <Stack spacing={1}>
      {includeRows.includes("money") &&
        renderSpecRow(
          "money",
          priceToBeConfirmed
            ? "To be confirmed"
            : `${standardVehicleValueFormatter(
                "listPriceIncGst",
                vehicleVariant.listPriceIncGst,
                { numberFormatter: "thousands" }
              )} - List Price`
        )}
      {includeRows.includes("speedometer") &&
        renderSpecRow(
          "speedometer",
          `${
            vehicleVariant.powerKw
              ? standardVehicleValueFormatter("powerKw", vehicleVariant.powerKw)
              : ""
          }${
            vehicleVariant.powerPlantType
              ? ` ${standardVehicleValueFormatter(
                  "powerPlantType",
                  vehicleVariant.powerPlantType,
                  { fallbacks: vehicleVariant.unMappedValues }
                )}`
              : ""
          }${
            vehicleVariant.driveDescription
              ? ` ${standardVehicleValueFormatter(
                  "driveDescription",
                  vehicleVariant.driveDescription,
                  { fallbacks: vehicleVariant.unMappedValues }
                )}`
              : ""
          }`
        )}
      {includeRows.includes("car") &&
        renderSpecRow(
          "car",
          `${vehicleVariant.doors} Door ${
            vehicleVariant.seatCapacity
          } Seat ${standardVehicleValueFormatter(
            "bodyType",
            vehicleVariant.bodyType,
            { fallbacks: vehicleVariant.unMappedValues }
          )}`,
          vehicleVariant.releaseYear
            ? `${formatReleaseDate(
                vehicleVariant.releaseYear,
                vehicleVariant.releaseMonth
              )} - Released`
            : undefined
        )}
      {includeRows.includes("range") &&
        (rangeText || fuelEconomyText) &&
        renderSpecRow("chart-line", rangeText ?? "", fuelEconomyText ?? "")}
    </Stack>
  );
};
